module.exports = __webpack_public_path__ + "static/media/radio-check-icon.0c8415c9.svg";